import React, { useMemo } from 'react'
import UseSelectorField from './useSelectorField'
import AvatarField from './Components/AvatarField'
import AvatarCompactField from './Components/AvatarCompactField'
import { Rating, useWindowDimensions } from '@Knowledge-OTP/znk-ui-components'
import NotesField from './Components/NotesField'
const UseColumnsEducators = (refetch = () => {}) => {
  
  const getRating = (rating) => {
    return (
      <div className='d-flex flex-row align-items-center'>
        <Rating mode='View' initialRating={rating} className='mr-2' />
        <label>{rating}/5</label>
      </div>
    )
  }
  const {breakWidth} = useWindowDimensions()
  return useMemo(() => {
    if(['MD'].includes(breakWidth)) {
      return [
        {
          render: (item) => <AvatarCompactField item={item}/>, id: 'name', colSpan: 5, className: ''
        },
        {
          render: (item) => getRating(item.educatorInfo?.rating), id: (item) => {return `updatedAt-${item.id}`}, colSpan: 5, className: 'justify-content-start align-items-center text-gray'
        },
        {
          optionsParser: (item) => {
            return UseSelectorField(item, 'educator')
          },
          type: 'selector',
          id: 'buttons',
          colSpan: 2,
          className: 'justify-content-end align-items-center'
        } 
      ]
    }
    else if ( ['SM'].includes(breakWidth) ) {
      return [
        {
          render: (item) => <AvatarCompactField item={item} />, id: 'name', colSpan: 8, className: ''
        },
        {
          optionsParser: (item) => {
            return UseSelectorField(item, 'educator')
          },
          type: 'selector',
          id: 'buttons',
          colSpan: 2,
          className: 'justify-content-end align-items-center'
        }
      ]
    }
    return [
      {
        render: item => <AvatarField item={item} />, id: 'name', colSpan: 2, className: 'justify-content-start align-items-center text-title'
      }, {
        render: (item) => item.emails[0].address, id: 'email', colSpan: 2, className: 'justify-content-start align-items-center text-gray'
      }, {
        render: (item) => `${item.phone || 'No defined'}`, id: 'phone', colSpan: 2, className: 'justify-content-start align-items-center text-gray'
      }, {
        render: (item) => <NotesField item={item} onSave={refetch}/>, id: 'notes', colSpan: 1, className: 'justify-content-start align-items-center text-gray'
      }, {
        render: (item) => getRating(item.educatorInfo?.rating), id: (item) => {return `updatedAt-${item.id}`}, colSpan: 1, className: 'justify-content-start align-items-center text-gray'
      }, {
        optionsParser: (item) => {
          return UseSelectorField(item, 'educator')
        },
        type: 'selector',
        id: 'buttons',
        colSpan: 2,
        className: 'justify-content-end align-items-center'
      }
    ]
    //eslint-disable-next-line
  }, [breakWidth, refetch])
}

export default UseColumnsEducators
